import { FC, useCallback } from 'react';
import ReactQuill from 'react-quill';
import { useField } from 'formik';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import 'react-quill/dist/quill.snow.css';

type Props = {
  name: string;
  disabled?: boolean;
  label?: string;
};

const LegacyEditor: FC<Props> = ({ name, disabled, label }) => {
  const [{ value = '' }, , { setValue }] = useField<string>(name);

  const handleChange = useCallback(
    (value: string) => {
      if (disabled) return;
      setValue(value);
    },
    [disabled, setValue]
  );

  return (
    <Box>
      {label && <Typography variant="caption">{label}</Typography>}
      <ReactQuill value={value} onChange={handleChange} />
    </Box>
  );
};

export default LegacyEditor;
